import React from 'react'

import {
  Check, Icon, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'
import SubscriptionTagIcon from 'Pods/Shared/Icons/SubscriptionTagIcon'

import { SUBSCRIPTION_LABEL_STATE, SUBSCRIPTION_LABEL_TIER } from './constants'

const CHECK_SIZE = { width: '16', height: '16' }

function SubscriptionLabel({ tier = null, state = SUBSCRIPTION_LABEL_STATE.FREE, locale = 'en' }) {
  const iconClassName = classnames('subscription-label__icon', `subscription-label__icon--${tier}`)

  return (
    <span
      className={classnames(
        'cgt-caption-semibold',
        'subscription-label',
        `subscription-label--${tier}`,
        `subscription-label--${state}`
      )}
    >
      {state === SUBSCRIPTION_LABEL_STATE.YOURS ? (
        <Icon svgComponent={Check} size={CHECK_SIZE} className={iconClassName} notSpaced aria-hidden="true" />
      ) : (
        <SubscriptionTagIcon className={iconClassName} width="16" height="16" aria-hidden="true" />
      )}
      <span className="subscription-label__text">
        {I18n.t(`listingPage.subscriptionLabel.${state}`, { ns: 'rails', lng: locale })}
      </span>
    </span>
  )
}

SubscriptionLabel.propTypes = {
  tier: oneOf(Object.values(SUBSCRIPTION_LABEL_TIER)),
  state: oneOf(Object.values(SUBSCRIPTION_LABEL_STATE)),
  locale: string,
}

export default SubscriptionLabel
